import { apiClient } from '../../api/client'
import APIs from '../../api/index'

// GET /api/guardian-roles — paginated list. Backend accepts `page` + `limit`
// (1-indexed) and returns the rows inside a triple-nested envelope:
//   { status, data: { data: Role[], meta: { total, page, limit, totalPages } } }
// Older callers passed no params and relied on `data.data.data`; pagination
// support is layered in here so they keep working untouched — when
// `page` / `limit` are omitted we don't send them (the backend falls back
// to its own defaults). Mirrors the pagination contract used by
// `listAccessPointsApi` and the guardian-users endpoint so the
// RolesTab can reuse the same `<PaginationFooter>` plumbing.
export const getRoleList = (params = {}) => {
  const { page, limit, search, orderBy, order } = params || {}
  const query = {}
  if (page) query.page = page
  if (limit) query.limit = limit
  if (search) query.search = search
  if (orderBy) query.orderBy = orderBy
  if (order) query.order = order
  return apiClient.get(APIs.ROLE_PERMISSION.getList, { params: query })
}

export const getRoleById = (roleUuid) =>
  apiClient.get(`${APIs.ROLE_PERMISSION.getRoleById}/${roleUuid}`)

export const createRole = (payload) => apiClient.post(APIs.ROLE_PERMISSION.createRole, payload)

export const updateRole = (roleUuid, payload) =>
  apiClient.put(`${APIs.ROLE_PERMISSION.updateRole}/${roleUuid}`, payload)

export const deleteRole = (roleUuid) =>
  apiClient.delete(`${APIs.ROLE_PERMISSION.deleteRole}${roleUuid}`)

export const getGuardianModules = () => apiClient.get(APIs.GUARDIAN_MODULES.list)
